import './modal.scss'

import React, { ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface ModalProps {
    toggleModal?(): void
    children?: ReactNode
}

export default class Modal extends React.PureComponent<ModalProps> {
    private modal: HTMLDivElement | null

    private outsideClickTimer: ReturnType<typeof setTimeout> | undefined

    componentDidMount() {
        this.outsideClickTimer = setTimeout(() => {
            document.body.addEventListener('click', this.onClickOutside, false)
        }, 0)
    }

    componentWillUnmount() {
        clearTimeout(this.outsideClickTimer)
        document.body.removeEventListener('click', this.onClickOutside, false)
    }

    onClickOutside = ({ target }: MouseEvent) => {
        const { toggleModal } = this.props
        if (this.modal && !this.modal?.contains(target) && toggleModal) {
            toggleModal()
        }
    }

    render() {
        const { children } = this.props
        return createPortal(
            <>
                <div className="overlay" />
                <div
                    className="modal"
                    ref={(node) => {
                        this.modal = node
                    }}
                >
                    {children}
                </div>
            </>,
            document.body
        )
    }
}

Modal.defaultProps = {
    toggleModal: undefined,
    children: undefined,
}
